import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'components/LazyImage';
import { values } from 'lodash/fp';
import cns from 'classnames';
import * as sellerTypes from 'constants/sellerType';

import cn from './styles.local.less';

export default class SellerInfo extends PureComponent {
  static propTypes = {
    location: PropTypes.object,
    sellerLogo: PropTypes.string,
    sellerName: PropTypes.string,
    sellerType: PropTypes.oneOf(values(sellerTypes)).isRequired,
    withMerchantInfo: PropTypes.bool,
  };

  renderAddress() {
    const {
      location: { city, country, zipcode },
    } = this.props;

    return (
      <div>
        {country} - {zipcode} {city}
      </div>
    );
  }

  render() {
    const { sellerName, sellerType, sellerLogo, withMerchantInfo } = this.props;

    return (
      <div className={cn.root}>
        {withMerchantInfo ? (
          <Fragment>
            {sellerLogo ? (
              <div>
                <LazyImage
                  className={cns(cn.logo, 'hidden-xs')}
                  src={sellerLogo}
                />
              </div>
            ) : null}
            <div>
              {sellerName ? <div>{sellerName}</div> : null}
              {this.renderAddress()}
              {sellerType === sellerTypes.MERCHANT
                ? __('merchant.type.label')
                : null}
            </div>
          </Fragment>
        ) : (
          this.renderAddress()
        )}
      </div>
    );
  }
}
